import React, { lazy, Suspense, useState } from 'react'
import { Routes, Route, Link, useLocation } from 'react-router-dom'
import { Layout, Menu, Spin, theme, Drawer, Button } from 'antd'
import { CalculatorOutlined, FontColorsOutlined, MenuOutlined } from '@ant-design/icons'
import AppFooter from './components/AppFooter'

import type { MenuProps } from 'antd'

const BaziTab = lazy(() => import('./pages/BaziTab'))
const WugeTab = lazy(() => import('./pages/WugeTab'))

const { Sider, Content } = Layout

const MenuSelector: React.FC<{ menuItems: MenuProps['items'] }> = ({ menuItems }) => {
  const location = useLocation()
  const selectedKey = location.pathname === '/' ? '/wuge' : location.pathname

  return (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      items={menuItems}
      style={{ borderRight: 0 }}
    />
  )
}

const App: React.FC = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken()

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const currentPath = location.pathname === '/' ? '/wuge' : location.pathname

  const menuItems: MenuProps['items'] = [
    {
      key: '/wuge',
      icon: <FontColorsOutlined />,
      label: <Link to="/wuge" onClick={() => setMobileMenuOpen(false)}>姓名打分</Link>,
    },
    {
      key: '/bazi',
      icon: <CalculatorOutlined />,
      label: <Link to="/bazi" onClick={() => setMobileMenuOpen(false)}>八字排盘</Link>,
    },
  ]

  return (
    <>
      {/* 手机端顶部导航栏 - 独立在 Layout 外部 */}
      <div className="mobile-header">
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={() => setMobileMenuOpen(true)}
          style={{ fontSize: 18 }}
        />
        <span style={{ marginLeft: 12, fontWeight: 600, fontSize: 16 }}>命理工具</span>
      </div>

      <Layout style={{ minHeight: '100vh' }}>
        {/* 桌面端侧边栏 */}
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          style={{ background: colorBgContainer }}
          className="desktop-sider"
        >
          <div style={{ padding: '16px', textAlign: 'center', fontWeight: 600, fontSize: 16 }}>
            命理工具
          </div>
          <MenuSelector menuItems={menuItems} />
        </Sider>

        {/* 手机端抽屉菜单 */}
        <Drawer
          title="导航"
          placement="left"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          width={200}
        >
          <Menu
            mode="inline"
            selectedKeys={[currentPath]}
            items={menuItems}
            onClick={() => setMobileMenuOpen(false)}
          />
        </Drawer>

        <Layout>
          <Content style={{ margin: '24px 16px 0' }}>
            <div
              style={{
                padding: 24,
                minHeight: 360,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
              }}
              className="main-content"
            >
              <Suspense fallback={<Spin size="large" style={{ display: 'block', margin: '80px auto' }} />}>
                <Routes>
                  <Route path="/" element={<WugeTab />} />
                  <Route path="/bazi" element={<BaziTab />} />
                  <Route path="/wuge" element={<WugeTab />} />
                </Routes>
              </Suspense>
            </div>
          </Content>
          <AppFooter />
        </Layout>
      </Layout>
    </>
  )
}

export default App